import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const painPoints = ['Tenés mil ideas en la cabeza y no sabés por dónde empezar.', 'Te da miedo invertir y que "no rinda".', 'Te cuesta cobrar lo que vale tu trabajo.', 'Publicás en redes y no llegan pedidos (o llegan pocos y no sabés por qué).', 'Sentís que vivís apagando incendios: compras, tiempos, mensajes, entregas.'];
  return <section className="py-20 md:py-28 bg-white relative border-t-8 border-coffee-dark" data-id="element-236">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-238">
          <h2 className="text-3xl md:text-5xl font-extrabold text-coffee-dark mb-8 leading-tight font-heading" data-id="element-239">
            Si te sentís identificada con esto,{' '}
            <span className="text-red-600 underline decoration-gold-matte" data-id="element-240">
              esta guía es para vos.
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-text-body mb-10 leading-relaxed font-medium" data-id="element-241">
            Te encanta la idea de los desayunos sorpresa, pero te pasa que:
          </p>
        </motion.div>

        <div className="space-y-4 mb-12 text-left max-w-2xl mx-auto" data-id="element-242">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-5 rounded-xl bg-red-50 border border-red-100 shadow-sm" data-id="element-243">
              <XCircleIcon className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-244" />
              <p className="text-coffee-dark font-semibold text-lg" data-id="element-245">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="p-8 md:p-10 rounded-2xl bg-gold-matte/10 border-2 border-gold-matte/30 relative" data-id="element-246">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-white px-4" data-id="element-247">
            <span className="text-3xl" data-id="element-248">💡</span>
          </div>
          <p className="text-2xl md:text-3xl text-coffee-dark font-heading font-bold leading-snug" data-id="element-249">
            No es falta de talento.{' '}
            <span className="text-gold-matte" data-id="element-250">
              Es falta de un sistema simple
            </span>{' '}
            que te diga: qué ofrecer, a cuánto, cómo hablarle a tu cliente y
            cómo cumplir sin explotar.
          </p>
        </motion.div>
      </div>
    </section>;
}